<nz-modal [nzTitle]="titleTpl" [nzVisible]="visible" [nzClosable]="false" [nzFooter]="null" nzWidth="700px"
  (nzOnCancel)="cancel()" [nzDraggable]="true" nzWrapClassName="account-code-modal" [nzOkDisabled]="loading"
  [nzAutofocus]="null">
  <ng-template #titleTpl>
    <div class="title-template">
      <span class="title">Account Entry</span>
      <div class="btn-header">
        <button type="button" nz-button class="cancel-btn" (click)="cancel()">Cancel</button>
        <ng-container *ngIf="canEdit">
          <nz-button-group>
            <button type="button" *ngIf="canCreate" nz-button nzType="primary" (click)="submit('new')"
              [disabled]="loading || isSaving" [nzLoading]="isSaving">Save & New</button>
            <button type="button" *ngIf="!canCreate" nz-button nzType="primary" (click)="submit('')" [disabled]="loading || isSaving"
              [nzLoading]="isSaving">Save</button>
            <button type="button" nz-button nz-dropdown [nzDropdownMenu]="saveList" nzPlacement="bottomRight" class="dropdown-btn"
              [disabled]="loading || isSaving" [nzLoading]="isSaving">
              <span nz-icon nzType="down" nzTheme="outline"></span>
            </button>
          </nz-button-group>
          <nz-dropdown-menu #saveList="nzDropdownMenu">
            <ul nz-menu class="hidden-btn">
              <li nz-menu-item (click)="submit('close')">Save & Close</li>
              <li *ngIf="canCreate" nz-menu-item (click)="submit('')">Save</li>
            </ul>
          </nz-dropdown-menu>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="loading">
      <form #form="ngForm" nz-form se-container="1">
        <nz-tabset [(nzSelectedIndex)]="activeTab">
          <nz-tab nzTitle="Details">
          </nz-tab>
          <nz-tab nzTitle="Payment Methods" *ngIf="shouldShowPaymentMethod">
          </nz-tab>
          <nz-tab nzTitle="Settings" *ngIf="shouldShowSettings">
          </nz-tab>
        </nz-tabset>
        <ng-container *ngIf="activeTab === 0">
          <se label="Account Type">
            {{ model.accountType ? model.accountType.name : '-' }}
          </se>
          <se label="Parent" error="Parent Account is required">
            <nz-tree-select #treeSelect [nzNodes]="data" name="treeSelect"
              [(ngModel)]="model.parentId" nzShowSearch required [nzAllowClear]="false" [nzBackdrop]="false"
              nzVirtualHeight="256px" [nzDropdownMatchSelectWidth]="false" (ngModelChange)="onParentModelChange($event)">
            </nz-tree-select>
          </se>
          <se label="Account Code" error="Account Code is required">
            <input nz-input app-auto-focus #autoFocus="autoFocus" name="code" required type="text" [(ngModel)]="model.code" />
          </se>
          <se label="Account Name" error="Account Name is required">
            <input nz-input name="name" required type="text" [(ngModel)]="model.name" />
          </se>
          <!-- advance currency -->
          <se label="Currency" error="Currency is required" required="required" acl="m1.128">
            <app-currency-select name="currency" [(ngModel)]="model.currency" (ngModelChange)="changeCurrency()"
              [allowEdit]="!model.inUse && !model.bankTypeCode && isBankOrCashAccount(model)" />
          </se>
          <se [label]="bankAccNoTemplt" *ngIf="model.specialCode === 'BAC'">
            <input nz-input name="bankAccountNo" type="text" app-digit-only maxlength="30"
              [(ngModel)]="model.bankAccountNo" [disabled]="model.bankTypeCode" />
          </se>
          <ng-template #bankAccNoTemplt>
            Bank Account No. <span nz-icon nz-tooltip nzType="question-circle" nzTheme="outline" style="color: #a7a8aa"
              [nzTooltipTitle]="model.bankTypeCode ? 'This account is linked in banking module' : 'Your bank account number for this bank account'"
              [nzTooltipTrigger]="isMobileView ? 'click' : 'hover'"></span>
          </ng-template>
          <se label="DR CR" error="DR CR is required">
            <nz-radio-group [(ngModel)]="model.drcr" name="drcr" required>
              <label nz-radio nzValue="DR">DEBIT</label>
              <label nz-radio nzValue="CR">CREDIT</label>
            </nz-radio-group>
          </se>
          <se label="Special Account Type">
            <nz-select [(ngModel)]="model.specialCode" name="specialCode" [nzDropdownMatchSelectWidth]="false"
              [disabled]="inUse || (parent && parent.parentId)" (ngModelChange)="specialCodeChanged($event)">
              <nz-option *ngFor="let item of displayedCodes" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
            </nz-select>
          </se>
          <se label="Cash Flow Type" *ngIf="!model.hasChildren">
            <nz-select [(ngModel)]="model.cashFlowType" name="cashFlowType" [nzDropdownMatchSelectWidth]="false"
              [nzAllowClear]="true">
              <nz-option nzLabel="None" [nzValue]="0"></nz-option>
              <nz-option nzLabel="Operating Activities" [nzValue]="1"></nz-option>
              <nz-option nzLabel="Financing Activities" [nzValue]="2"></nz-option>
              <nz-option nzLabel="Investing Activities" [nzValue]="3"></nz-option>
            </nz-select>
          </se>
          <se label="Tariff Code" *ngIf="country === 'MY'">
            <app-tariff-tax-code-select name="tariffCode" [(ngModel)]="model.tariffCode" valueField=""
              (ngModelChange)="tariffCodeChanged($event)">
            </app-tariff-tax-code-select>
          </se>
          <se label="Status">
            <nz-switch [nzSize]="'default'" nzCheckedChildren="Active" nzUnCheckedChildren="Inactive"
              [(ngModel)]="model.isActive" name="isActive"></nz-switch>
          </se>
        </ng-container>

        <ng-container *ngIf="activeTab === 1">
          <se hideLabel="true">
            <nz-table #einvPaym [nzData]="model.eInvoicePaymentMethod" [nzFrontPagination]="false"
              [nzShowPagination]="false" nzBordered="true" nzSize="small">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Description</th>
                  <th>Payment Mode</th>
                </tr>
              </thead>
              <tbody>
                @for(
                item of einvPaym.data;
                track item;
                let i = $index
                ) {
                <tr>
                  <td>{{ item.code }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ convertToDisplay(item.mode) }}</td>
                </tr>
                }
              </tbody>
            </nz-table>
          </se>
        </ng-container>

        <ng-container *ngIf="activeTab === 2">
          <se hideLabel="true">
            <span>Use Auto Cheque Number: </span> <nz-switch (ngModelChange)="autoBankParamChanged('cheque', $event)"
              [(ngModel)]="model.bankAccountAutoChequeNumber" name="bankAccountAutoChequeNumber"
              style="margin-left: 5px;margin-right: 10px;"></nz-switch>
            <span>Allow Edit: </span> <nz-switch [(ngModel)]="model.bankAccountChequeNumberEdit"
              name="bankAccountChequeNumberEdit" style="margin-left: 5px;"></nz-switch>
          </se>
          <se label="Format" labelWidth="175">
            <nz-select class="width" nzPlaceHolder="N/A" nzMode="default"
              [nzDisabled]="!model.bankAccountAutoChequeNumber" [(ngModel)]="model.bankAccountChequeNumberFormat"
              name="bankAccountChequeNumberFormat">
              <nz-option *ngFor="let item of formats.cheque" [nzLabel]="item.format"
                [nzValue]="item.format"></nz-option>
            </nz-select>
          </se>
          <se hideLabel="true">
            <span>Use Own Receipt Voucher: </span> <nz-switch (ngModelChange)="autoBankParamChanged('receipt', $event)"
              [(ngModel)]="model.autoBankReceiptCode" name="autoBankReceiptCode"
              style="margin-left: 5px;margin-right: 10px;"></nz-switch>
          </se>
          <se label="Format" labelWidth="175">
            <nz-select class="width" nzPlaceHolder="N/A" nzMode="default" [nzDisabled]="!model.autoBankReceiptCode"
              [(ngModel)]="model.autoBankReceiptFormatId" name="autoBankReceiptFormatId">
              <nz-option *ngFor="let item of formats.receipt" [nzLabel]="item.format" [nzValue]="item.id"></nz-option>
            </nz-select>
          </se>
          <se hideLabel="true">
            <span>Use Own Payment Voucher: </span> <nz-switch (ngModelChange)="autoBankParamChanged('payment',$event)"
              [(ngModel)]="model.autoBankPaymentCode" name="autoBankPaymentCode"
              style="margin-left: 5px;margin-right: 10px;"></nz-switch>
          </se>
          <se label="Format" labelWidth="175">
            <nz-select class="width" nzPlaceHolder="N/A" nzMode="default" [nzDisabled]="!model.autoBankPaymentCode"
              [(ngModel)]="model.autoBankPaymentFormatId" name="autoBankPaymentFormatId">
              <nz-option *ngFor="let item of formats.payment" [nzLabel]="item.format" [nzValue]="item.id"></nz-option>
            </nz-select>
          </se>
        </ng-container>
      </form>
    </nz-spin>
  </ng-container>
</nz-modal>